import { useLang } from '../i18n/context';
import { Reveal } from './Reveal';

export default function Journey({ light = false }) {
    const { t } = useLang();
    return (
        <div data-testid="treatment-journey">
            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-7 lg:gap-3">
                {t.journeySteps.map((s, i) => (
                    <Reveal key={s.k} delay={i * 0.06}>
                        <div className={`group h-full rounded-2xl border p-5 transition-colors duration-300 ${light ? 'border-white/15 hover:bg-white/10' : 'border-peri-200 bg-white hover:border-gold-500 hover:shadow-card-hover'}`}>
                            <span className={`font-serif text-2xl italic ${light ? 'text-peri-300' : 'text-peri-400'}`}>{s.k}</span>
                            <p className={`mt-2 text-sm font-bold tracking-wide ${light ? 'text-white' : 'text-gold-700'}`}>{s.t}</p>
                            <p className={`mt-1.5 text-[13px] leading-relaxed ${light ? 'text-peri-200' : 'text-ink-muted'}`}>{s.d}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.2}>
                <p className={`mt-6 text-sm italic ${light ? 'text-peri-300' : 'text-ink-subtle'}`}>{t.journeyNote}</p>
            </Reveal>
        </div>
    );
}
